<template>
    <div>
        <v-card
            v-if="parseInt(step) === 1 && loadingStep1"
            class="mb-3">
            <v-layout
                v-if="loadingStep1"
                :style="{ height: heightCard }"
                column
                fill-height
                justify-center
                align-center
            >
                <v-progress-circular
                :size="50"
                color="primary"
                indeterminate />
            </v-layout>
        </v-card>
        <div v-show="!(parseInt(step) === 1 && loadingStep1)">
            <v-layout
                justify-space-between
                row
                wrap>
                <h4 class="v-toolbar__title">
                {{ strings[idioma].dados_animal }}
                </h4>
                <div>
                <v-btn
                    v-if="
                    stepComplete[0] ||
                        stepComplete[1] ||
                        stepComplete[2] ||
                        stepComplete[3] ||
                        stepComplete[4]
                    "
                    :title="strings[idioma].botao_reset"
                    :disabled="edicaoBloqueada"
                    color="error"
                    @click="resetDieta"
                >
                    <v-icon>mdi-delete</v-icon>
                    &nbsp;
                    {{ strings[idioma].botao_reset }}
                </v-btn>
                </div>
            </v-layout>
            <v-layout
                v-if="validAnimal != null && !validAnimal"
                row>
                <span style="color: #f52b1b; font-weight: 400">{{
                strings[idioma].dados_invalidos
                }}</span>
            </v-layout>

            <span
                v-if="stepComplete[0]"
                style="color: black; font-weight: 400"
            >{{ strings[idioma].aviso_edicao }}</span
            >
            <p>
                <span
                v-if="stepComplete[0] && animal.tipo.valor !== BEZERRO"
                style="color: black; font-weight: 400"
                >** {{ strings[idioma].obrigatorio_relatorio_financeiro }}</span>
            </p>
            <v-card
                v-if="parseInt(step) === 1"
                class="mb-3">
                <div
                v-if="
                    dieta_salva &&
                    dieta_salva.dieta &&
                    dieta_salva.dieta.dieta_ativa
                "
                class="blue pa-2 text-xs-center white--text py-1"
                style="width: 100%; border-radius: 10px; opacity: 0.8"
                wrap
                >
                <h5>
                    {{
                    strings[idioma][
                        dieta_salva.dieta.dieta_ativa.tipo_confinamento
                    ]
                        ? strings[idioma][
                        dieta_salva.dieta.dieta_ativa.tipo_confinamento
                        ]
                        : dieta_salva.dieta.dieta_ativa.tipo_confinamento
                    }}
                </h5>
                <p>
                    {{ strings[idioma].data_inicial }}:
                    {{
                    moment(dieta_salva.dieta.dieta_ativa.data_inicio).format(
                        strings[idioma].formato_datas_sem_hora
                    )
                    }}; {{ strings[idioma].data_final_estimada }}:
                    {{
                    moment(
                        dieta_salva.dieta.dieta_ativa.data_fim_esperado
                    ).format(strings[idioma].formato_datas_sem_hora)
                    }}; {{ strings[idioma].data_final_real }}:
                    {{
                    dieta_salva.dieta.dieta_ativa.data_fim_real === null
                        ? "-"
                        : moment(
                        dieta_salva.dieta.dieta_ativa.data_fim_real
                        ).format(strings[idioma].formato_datas_sem_hora)
                    }}
                    <br >{{ strings[idioma].gmd_real }}:
                    {{
                    dieta_salva.dieta.dieta_ativa.gmd_real === null
                        ? "-"
                        : dieta_salva.dieta.dieta_ativa.gmd_real
                    }}
                    kg; {{ strings[idioma].peso_abate }}:
                    {{
                    dieta_salva.dieta.dieta_ativa.peso_abate === null
                        ? "-"
                        : dieta_salva.dieta.dieta_ativa.peso_abate
                    }}
                    kg
                </p>
                <v-btn
                    :disabled="
                    edicaoBloqueada && user.id !== dietaCarregada.user_id
                    "
                    color="primary"
                    small
                    dark
                    @click="editarDietaAtiva(dieta_salva.dieta)"
                >{{ strings[idioma].editar }}</v-btn
                >
                <template
                    v-if="dieta_salva.dieta.dieta_ativa.data_fim_real !== null"
                >
                    <v-btn
                    :disabled="
                        edicaoBloqueada && user.id !== dietaCarregada.user_id
                    "
                    color="warning"
                    small
                    dark
                    @click="reabrirDietaAtiva(dieta_salva.dieta)"
                    >{{ strings[idioma].reabrir_dieta }}</v-btn
                    >
                </template>
                <template
                    v-if="dieta_salva.dieta.dieta_ativa.data_fim_real === null"
                >
                    <v-btn
                    :disabled="
                        edicaoBloqueada && user.id !== dietaCarregada.user_id
                    "
                    color="warning"
                    small
                    dark
                    @click="finalizarDieta(dieta_salva.dieta)"
                    >{{ strings[idioma].finalizar }}</v-btn
                    >
                    <v-btn
                    :disabled="
                        edicaoBloqueada && user.id !== dietaCarregada.user_id
                    "
                    color="error"
                    small
                    dark
                    @click="desativarDieta(dieta_salva.dieta)"
                    >{{ strings[idioma].desativar_dieta }}</v-btn
                    >
                </template>
                </div>
                <v-form
                ref="formAnimal"
                v-model="validAnimal"
                lazy-validation
                @submit.prevent="etapa2()"
                >
                <v-layout
                    row
                    wrap>
                    <v-flex
                    v-for="(input, name) in animal"
                    :key="name"
                    :class="
                        input.tipo != TIPO_RADIOBUTTOM
                        ? 'xs12 sm6 md4 lg3'
                        : 'xs12'
                    "
                    :style="displayCondicional(input, animal)"
                    pa-2
                    >
                    <div v-if="renderCondicional(input, animal)">
                        <v-text-field
                        v-if="input.tipo === TIPO_NUMBER"
                        v-show="!input.oculta"
                        :disabled="edicaoBloqueada"
                        :label="
                            input.required
                            ? input.title[idioma] + ' *'
                            : input.requiredFin ?
                                input.title[idioma] + ' **'
                                : input.title[idioma]
                        "
                        :rules="rulesAnimal(input, animal, idioma)"
                        v-model.lazy="input.valor"
                        :class="
                            'input-form-animal ' +
                            displayCondicional(input, animal)
                        "
                        :lang="idioma === 0 ? 'pt-br' : (idioma === 1) ? 'en-us' : 'es-ES'"
                        pattern="\d*"
                        inputmode="decimal"
                        @focus="input.focus = true"
                        @blur="input.focus = false"
                        @paste="
                            (evt) => $validateOnlyNumbers(evt, true, idioma)
                        "
                        @click="
                            parseString(input.valor, idioma) === 0
                            ? (input.valor = '')
                            : ''
                        "
                        @keypress="(val) => onlyFloat(val, input, 'valor')"
                        @change="
                            (evt) => {
                            limpezaDeDados(input, 0, calculo1, [animal]);
                            }
                        "
                        />
                        <v-text-field
                        v-if="input.tipo === TIPO_FLOAT2"
                        v-show="!input.oculta"
                        :disabled="edicaoBloqueada"
                        :label="
                            input.required
                            ? input.title[idioma] + ' *'
                            : input.requiredFin ?
                                input.title[idioma] + ' **'
                                : input.title[idioma]
                        "
                        :rules="rulesAnimal(input, animal, idioma)"
                        v-model.lazy="input.valor"
                        :class="
                            'input-form-animal ' +
                            displayCondicional(input, animal)
                        "
                        :lang="idioma === 0 ? 'pt-br' : (idioma === 1) ? 'en-us' : 'es-ES'"
                        pattern="\d*"
                        inputmode="decimal"
                        @focus="input.focus = true"
                        @blur="input.focus = false"
                        @paste="
                            (evt) => $validateOnlyNumbers(evt, true, idioma)
                        "
                        @keypress="(val) => onlyFloat(val, input, 'valor')"
                        @change="limpezaDeDados(input, 2, calculo1, [animal])"
                        />
                        <v-text-field
                        v-if="input.tipo === TIPO_FLOAT_LIVRE"
                        v-show="!input.oculta"
                        :disabled="edicaoBloqueada"
                        :label="
                            input.required
                            ? input.title[idioma] + ' *'
                            : input.requiredFin ?
                                input.title[idioma] + ' **'
                                : input.title[idioma]
                        "
                        :rules="rulesAnimal(input, animal, idioma)"
                        v-model.lazy="input.valor"
                        :class="
                            'input-form-animal ' +
                            displayCondicional(input, animal)
                        "
                        :lang="idioma === 0 ? 'pt-br' : (idioma === 1) ? 'en-us' : 'es-ES'"
                        pattern="\d*"
                        inputmode="decimal"
                        @focus="input.focus = true"
                        @blur="input.focus = false"
                        @paste="
                            (evt) => $validateOnlyNumbers(evt, true, idioma)
                        "
                        @keypress="(val) => onlyFloat(val, input, 'valor')"
                        @click="
                            parseString(input.valor, idioma) === 0
                            ? (input.valor = '')
                            : ''
                        "
                        @change="limpezaDeDados(input, 2, calculo1, [animal])"
                        />
                        <v-text-field
                        v-if="input.tipo === TIPO_PORCENTAGEM"
                        v-show="!input.oculta"
                        :disabled="edicaoBloqueada"
                        :label="input.required
                            ? input.title[idioma] + ' *'
                            : input.requiredFin ?
                            input.title[idioma] + ' **'
                        : input.title[idioma]"
                        :rules="rulesAnimal(input, idioma)"
                        v-model.lazy="input.valor"
                        :class="
                            'input-form-animal ' +
                            displayCondicional(input, animal)
                        "
                        suffix="%"
                        pattern="\d*"
                        inputmode="decimal"
                        @focus="input.focus = true"
                        @blur="input.focus = false"
                        @paste="
                            (evt) => $validateOnlyNumbers(evt, true, idioma)
                        "
                        @keypress="(val) => onlyFloat(val, input, 'valor')"
                        @change="limpezaDeDados(input, 2, calculo1, [animal])"
                        />
                        <v-text-field
                        v-if="input.tipo === TIPO_PORCENTAGEM_LIVRE"
                        v-show="!input.oculta"
                        :disabled="edicaoBloqueada"
                        :label="input.required
                            ? input.title[idioma] + ' *'
                            : input.requiredFin ?
                            input.title[idioma] + ' **'
                        : input.title[idioma]"
                        :rules="rulesAnimal(input, idioma)"
                        v-model.lazy="input.valor"
                        :class="
                            'input-form-animal ' +
                            displayCondicional(input, animal)
                        "
                        pattern="\d*"
                        inputmode="decimal"
                        suffix="%"
                        @focus="input.focus = true"
                        @blur="input.focus = false"
                        @keypress="(val) => onlyFloat(val, input, 'valor')"
                        @click="
                            parseString(input.valor, idioma) === 0
                            ? (input.valor = '')
                            : ''
                        "
                        @paste="
                            (evt) => $validateOnlyNumbers(evt, true, idioma)
                        "
                        @change="limpezaDeDados(input, 2, calculo1, [animal])"
                        />
                        <v-text-field
                        v-if="input.tipo === TIPO_MONEY"
                        v-show="!input.oculta"
                        :disabled="edicaoBloqueada"
                        :label="input.required
                            ? input.title[idioma] + ' *'
                            : input.requiredFin ?
                            input.title[idioma] + ' **'
                        : input.title[idioma]"
                        v-model.lazy="input.valor"
                        :prefix="strings[idioma].moeda_abrev"
                        :class="
                            'input-form-animal ' +
                            displayCondicional(input, animal)
                        "
                        pattern="\d*"
                        inputmode="decimal"
                        @focus="input.focus = true"
                        @blur="input.focus = false"
                        @keypress="(val) => onlyFloat(val, input, 'valor')"
                        @click="
                            parseString(input.valor, idioma) === 0
                            ? (input.valor = '')
                            : ''
                        "
                        @paste="
                            (evt) => $validateOnlyNumbers(evt, true, idioma)
                        "
                        @change="limpezaDeDados(input, 2, calculo1, [animal])"
                        />
                        <v-text-field
                        v-if="input.tipo === TIPO_RESULTADO"
                        v-show="!input.oculta"
                        :label="input.required
                            ? input.title[idioma] + ' *'
                            : input.requiredFin ?
                            input.title[idioma] + ' **'
                        : input.title[idioma]"
                        v-model="input.valor"
                        :class="
                            'input-form-animal disabled' +
                            displayCondicional(input, animal)
                        "
                        pattern="\d*"
                        inputmode="decimal"
                        disabled
                        readonly
                        />
                        <div v-else-if="input.tipo === TIPO_RADIOBUTTOM">
                        <label
                            v-if="input.title"
                            class="label-radio">{{
                            input.title[idioma]
                            }}</label>
                        <v-radio-group
                            v-show="!input.oculta"
                            v-model="input.valor"
                            v-bind="binding"
                            :disabled="edicaoBloqueada"
                            :rules="
                            proximoAnimalClick
                                ? [(v) => !!v || strings[idioma].obrigatorio]
                                : []
                            "
                            :key="input.valor"
                            @change="
                            changeRadioAnimal(input, animal);
                            calculo1(animal);
                            stepComplete[0] = false;
                            "
                        >
                            <template v-for="option in input.options">
                            <v-tooltip
                                :key="option.valor"
                                right>
                                <template v-slot:activator="{ on }">
                                <v-radio
                                    :title="strings[idioma][option.alt]"
                                    :key="option.valor"
                                    :label="option.title[idioma]"
                                    :value="option.valor"
                                    :disabled="edicaoBloqueada"
                                    :style="
                                    displayRadioCondicional(input, option, animal)
                                    "
                                    color="primary"
                                    v-on="option.alt ? on : null"
                                />
                                </template>
                                <span v-if="option.alt">{{ strings[idioma][option.alt] }}</span>
                            </v-tooltip>
                            </template>
                        </v-radio-group>
                        </div>
                    </div>
                    </v-flex>

                </v-layout>
                </v-form>
            </v-card>
            <v-layout
                row
                wrap
                justify-space-between>
                <span style="color: red">
                <v-btn
                    v-show="getAcessoModulo({ user: user, modulo: SALVAR_DIETA })"
                    flat
                    color="black"
                    @click="dietasDialog = true"
                >
                    <v-icon>mdi-folder-open</v-icon>
                    &nbsp;
                    {{ strings[idioma].abrir_dieta }}
                </v-btn>
                
                <v-dialog
                    v-model="dietasDialog"
                    max-width="450">
                    <v-card>
                    <v-layout>
                        <v-card
                        :style="'min-width: 450px; max-width: 100%; max-height:500px; overflow: auto; overflow-y: hidden; z-index:999;'"
                        >
                        <DietasCard />
                        </v-card>
                    </v-layout>
                    <v-card-actions>
                        <v-spacer />
                        <v-btn
                        :title="strings[idioma].fechar"
                        color="error"
                        small
                        @click="dietasDialog = false"
                        >
                        <v-icon dark>mdi-close</v-icon>
                        </v-btn>
                    </v-card-actions>
                    </v-card>
                </v-dialog>
                </span>
                <span>
                <template v-if="getAcessoModulo({ user: user, modulo: SALVAR_DIETA })">
                    <ClonarDieta :dieta="dieta_salva" :clientes="clientes" :tipo="'FD'" :label="strings[idioma].clonar_dieta" :onSuccess="resolveClone" :onError="resolveClone" />
                </template>
                </span>

                <span
                v-if="alerta !== null && alerta !== ''"
                style="color: red">
                {{ alerta }}
                <v-dialog
                    v-model="alertaDialog"
                    :close-on-content-click="false"
                    top
                    offset-y
                    max-width="300"
                    transition="slide-x-transition"
                >
                    <template v-slot:activator="{ on }">
                    <v-btn
                        flat
                        icon
                        color="black"
                        v-on="on">
                        <v-icon>mdi-information-outline</v-icon>
                    </v-btn>
                    </template>
                    <v-layout>
                    <v-card style="overflow: auto; z-index: 999">
                        <v-layout
                        pa-2
                        align-center
                        row
                        class="elevation-3 white--text"
                        style="background-color: #5c4848; width: 100%"
                        >
                        <v-flex
                            v-for="(item, index) in BezerrosInstrucoes[idioma]
                            .header"
                            :key="index"
                            style="width: 33%"
                        >
                            <strong>{{ item.titulo }}</strong>
                        </v-flex>
                        </v-layout>
                        <template>
                        <v-layout
                            v-for="(item, index) in BezerrosInstrucoes[idioma]
                            .data"
                            :key="index"
                            align-center
                            row
                            class="elevation-1"
                        >
                            <template>
                            <v-flex
                                pa-2
                                xs4
                                style="width: 33%; font-size: small"
                            >{{ item.SL }}</v-flex
                            >
                            <v-flex
                                pa-2
                                xs4
                                style="width: 33%; font-size: small"
                            >{{ item.PCMmin }}</v-flex
                            >
                            <v-flex
                                pa-2
                                xs4
                                style="width: 33%; font-size: small"
                            >{{ item.PCMmax }}</v-flex
                            >
                            </template>
                        </v-layout>
                        </template>
                        <v-card-actions>
                        <v-spacer />
                        <div style="padding: 2px">
                            <i
                            style="font-size: 10pt"
                            >{{ strings[idioma].peso_corporal_medio }}:
                            {{ animal.peso_corporal_medio.valor }}</i
                            >
                        </div>
                        <v-spacer />
                        <v-btn
                            :title="strings[idioma].fechar"
                            color="error"
                            small
                            @click="alertaDialog = false"
                        >
                            <v-icon dark>mdi-close</v-icon>
                        </v-btn>
                        </v-card-actions>
                    </v-card>
                    </v-layout>
                </v-dialog>
                </span>
                <v-btn
                color="primary"
                @click="etapa2()">
                {{ strings[idioma].botao_seguinte }}
                <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
            </v-layout>
        </div>
    </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
export default {
    computed: {
        ...mapState('app', [
        'animal',
        'animal_',
        'strings',
        'idioma',
        'restricoes',
        'optionsNumber',
        'headersExigencias',
        'dieta_salva',
        'exigencias',
        'exigencias_selecionadas',
        'exigencias_resultados',
        'categorias_alimentos',
        'alimentos_selecionados',
        'ingredientes',
        'composicao_racao',
        'composicao_dieta',
        'vc',
        'fixavc',
        'headersComposicaoRacao',
        'excrecao',
        'headersExigenciasRelatorio',
        'relatorio_financeiro',
        'relatorio_financeiro_cenarios',
        'headersRelatorioFinanceiro',
        'reset_options',
        'trava_back',
        'save_options',
        'exportando_dados',
        'leiteDeVaca',
        'dieta_calculada',
        'acesso_premium',
        'user',
        'empresa'
        ])
    }
}
    
</script>